// Quotes              https://en.wikipedia.org/wiki/Quotation_mark
// Language codes:     https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
module.exports = {
  'af':      '“”‘’',   // Afrikaans
  'sq':      '„“‘’',   // Albanian
  'az':      '«»‹›',   // Azerbaijani
  'eu':      '«»‹›',   // Basque
  'be':      '«»“”',   // Belarusian
  'bg':      '„“’’',   // Bulgarian
  'ca':      '«»“”',   // Catalan
  'zh-Hans': '“”‘’',   // Chinese, simplified
  'hr':      '„”‘’',   // Croatian
  'cs':      '„“‚‘',   // Czech
  'da':      '»«›‹',   // Danish
  'nl':      '‘’“”',   // Dutch
  'en-uk':   '‘’“”',   // English, UK
  'en-us':   '“”‘’',   // English, US; English, Canada
  'eo':      '“”‘’',   // Esperanto
  'et':      '„“«»',   // Estonian
  'fil':     '“”‘’',   // Filipino
  'fi':      '””’’',   // Finnish
  'fr':      '«»“”',   // French
  'fr-sw':   '«»‹›',   // French, Swiss
  'ka':      '„““”',   // Georgian
  'de':      '„“‚‘',   // German
  'de-sw':   '«»‹›',   // German, Swiss
  'el':      '«»“”',   // Greek
  'he':      '""\'\'', // Hebrew
  'hu':      '„”»«',   // Hungarian
  'is':      '„“‚‘',   // Icelandic
  'id':      '“”‘’',   // Indonesian
  'ga':      '“”‘’',   // Irish
  'it':      '«»“”',   // Italian
  'it-sw':   '«»‹›',   // Italian, Swiss
  'ko':      '“”‘’',   // Korean
  'lv':      '«»„“',   // Latvian
  'mk':      '„“’‘',   // Macedonian
  'no':      '«»’’',   // Norwegian
  'pl':      '„”«»',   // Polish
  'pt-br':   '“”‘’',   // Portuguese, Brazil
  'pt-pl':   '«»“”',   // Portuguese, Portugal
  'ro':      '„”«»',   // Romanian
  'ru':      '«»„“',   // Russian
  'sr':      '„”’’',   // Serbian
  'sk':      '„“‚‘',   // Slovak
  'sl':      '„“‚‘',   // Slovene
  'es':      '«»“”',   // Spanish
  'sv':      '””’’',   // Swedish
  'th':      '“”‘’',   // Thai
  'tr':      '“”‘’',   // Turkish
  'uk':      '«»„“',   // Ukrainian
  'cy':      '‘’“”'    // Welsh
};
